/** @file Fieldset renders a fieldset element that works well with RadioButtons and Checkboxes components. */
import * as tsx from 'vue-tsx-support';
import * as constants from '@/components/Form/constants';
import * as utils from '@/utils';
import { Description } from '../Description';
import { commonProps } from './shared';
/** Fieldset component that is used to wrapped choices in choice components. */
export const Fieldset = tsx.component({
    name: constants.nameFieldset,
    props: commonProps,
    computed: {
        /** @returns The classes for the children container. */
        childrenContainerClasses() {
            return [
                'flex flex-col',
                {
                    default: 'gap-1',
                    'card-like': [
                        'rounded overflow-hidden',
                        'bg-white dark:bg-neutral-60',
                        'border-neutral-5 divide-y divide-neutral-5 dark:divide-neutral-80',
                    ],
                    quiz: ['gap-y-3'],
                }[this.variant],
                this.optionsWrapperClasses,
            ];
        },
    },
    /** @returns VNodes. */
    render() {
        return (<fieldset data-cy={constants.nameFieldset} class={[constants.nameField, constants.nameFieldset, 'group']} disabled={this.disabled}>
                {/*
                <legend> in <fieldset> does not obey the rule of CSS Grid.
                Setting display:contents for it, and style a generic <span> element within.
            */}
                <legend class="contents">
                    <span class={[
                constants.nameLabel,
                'label-large',
                'self-start',
                {
                    'mt-1': this.variant === 'default',
                    'mt-2': this.variant === 'card-like',
                    'sr-only': this.variant === 'quiz',
                },
                this.legendClasses,
            ]}>
                        {this.legend}
                    </span>
                    {utils.ifOrEmpty(this.description != null, () => (<Description>{this.description}</Description>))}
                </legend>
                <div class={this.childrenContainerClasses}>{this.$slots.default}</div>
            </fieldset>);
    },
});
